import * as angular from 'angular';
import { DashboardThumbnailWidget } from '../../../widgets';
import { Dashboard, ComponentDefinition, TileBackground } from '../../../models';
import { WideError, dashboardUpdated, whiteBackgroundColor } from '../../../common';
import { IFilePathsHelper } from '../../../services';

class DashboardTileController implements angular.IComponentController {
    background: TileBackground;
    dashboard: Dashboard;
    duplicate: (value: { [key: string]: any }) => void;
    errorLevel: number = 0;
    onImageClick: (value: { [key: string]: any }) => void;
    thumbnail: DashboardThumbnailWidget;
    wideError: WideError;

    private _garbages: (() => void)[] = [];

    static $inject = ['$scope', 'filePathsHelper'];

    constructor(
        private _$scope: angular.IScope,
        private _filePathsHelper: IFilePathsHelper
    ) {
    }

    $onInit() {
        this._garbages.push(
            this._$scope.$on(dashboardUpdated, (event, data) => {
                this.refresh();
            })
        );

        this.refresh();
    }

    $onDestroy() {
        if (this._garbages) {
            this._garbages.forEach(g => g());
        }
    }

    refresh() {
        this.background = this.getBackground(this.dashboard);
    }

    hasError(): boolean {
        let hasError: boolean = false;
        if (this.thumbnail && this.thumbnail.getError) {
            const wideError = this.thumbnail.getError();
            if (wideError) {
                if (wideError.level === 3) {
                    hasError = true;
                }
            }
        }
        return hasError;
    }

    hasWarning(): boolean {
        let hasError: boolean = false;
        if (this.thumbnail && this.thumbnail.getError) {
            const wideError = this.thumbnail.getError();
            if (wideError) {
                if (wideError.level === 2) {
                    hasError = true;
                }
            }
        }
        return hasError;
    }

    onBackgroundClick(event) {
        if (this.onImageClick) {
            this.onImageClick({ event, thumbnail: this.thumbnail });
            event.preventDefault();
        }
    }

    private getBackground(data: Dashboard): TileBackground {
        let background = {} as TileBackground;
        let url = data.backgroundUrl;
        if (url) {
            url = `${this._filePathsHelper.getContentUrl()}${url}`;
            background = {
                url,
                color: whiteBackgroundColor,
                title: 'View dashboard'
            } as TileBackground;
        } else {
            background = {
                title: 'View dashboard'
            } as TileBackground;
        }

        return background;
    }
}

export const wtDashboardTile: ComponentDefinition = {
    componentId: 'wtDashboardTile',
    controller: DashboardTileController,
    template: require('./dashboardTile.component.html'),
    controllerAs: 'vm',
    bindings: {
        thumbnail: '<',
        dashboard: '<',
        isSelected: '<',
        onImageClick: '&?',
        isEditMode: '<?',
        isDataLoaded: '<'
    }
};